module.exports = __webpack_public_path__ + "img/ringsize@2x.d32f41f.webp";